export const COMPASS_POC_EMAILS = new Set([
	'chris.mattioli.test@anywhere.com',
	'ginger.shukrun.test@anywhere.com',
	'joshua.solow.test@anywhere.com',
	'linda.rogers.test@anywhere.com',
	'marc.pina.test@anywhere.com',
	'sabrina.evans.test@anywhere.com',
	'franco.demarco.test@anywhere.com',
	'jaclyn.ball.test@anywhere.com',
	'kristen.holloway.test@anywhere.com',
	'nathonas.duro.test@anywhere.com',
])

export function isCompassPocUser(email?: string | null): boolean {
	if (!email) return false
	const lower = email.toLowerCase()
	if (COMPASS_POC_EMAILS.has(lower)) return true
	// Profile email may omit ".test" (e.g. chris.mattioli@anywhere.com vs chris.mattioli.test@anywhere.com)
	return COMPASS_POC_EMAILS.has(lower.replace('@', '.test@'))
}

export function getSubFromIdToken(idToken?: string | null): string | undefined {
	if (!idToken) return undefined
	try {
		const payload = JSON.parse(Buffer.from(idToken.split('.')[1], 'base64').toString())
		return payload?.sub ?? undefined
	} catch {
		return undefined
	}
}
